import axios, {AxiosRequestConfig} from 'axios';
import Amplify, {Auth} from 'aws-amplify';

import awsconfig from '../backendConfigProvider';

Amplify.configure(awsconfig);

// TODO: move to auth service once this file is ts
export const getAuthHeaders = async () => {
  const headers = {};
  try {
    const authSession = await Auth.currentSession();
    headers['Authorization'] = `Bearer ${
      authSession.getAccessToken().getJwtToken()
    }`;
  } catch (error) {
    // ignore
  }
  return headers;
};

export const Configuration= {
  'ApplicationApiDomain': process.env.ApplicationApiDomain,
  'SignupApiDomain': process.env.SignupApiDomain,
  'AssessmentApiDomain': process.env.AssessmentApiDomain,
  'PricingApiDomain': process.env.PricingApiDomain,
  'BulkUploadDomain': process.env.BulkUploadDomain,
  'VoucherWrapperApiDomain': process.env.VoucherWrapperApiDomain,
  'ScormCloudWrapperApiDomain': process.env.ScormCloudWrapperApiDomain,
};
/**
TODO:
**/
class RestApi {
  /**
   * Creates an instance of RestApi.
   * @memberof RestApi
   */
  constructor() {
    this.apiDomain = Configuration.ApplicationApiDomain;
    this.signupApiDoman = Configuration.SignupApiDomain;
    this.typeFormApi = 'https://api.typeform.com/forms/';
    this.assessmentApiDomain = Configuration.AssessmentApiDomain;
    this.PricingApiDomain = Configuration.PricingApiDomain;
    this.BulkUploadDomain = Configuration.BulkUploadDomain;
    this.voucherWrapperApiDomain = Configuration.VoucherWrapperApiDomain;
    this.scormCloudWrapperApiDomain = Configuration.ScormCloudWrapperApiDomain;
  }
  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getApiDomain() {
    return this.apiDomain;
  }

  /**
  *
  *
  * @return {*}
  * @memberof RestApi
  */
  getSignupApiDomain() {
    return this.signupApiDoman;
  }

  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getTypeFormDomain() {
    return this.typeFormApi;
  }
  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getAssessmentApiDomain() {
    return this.assessmentApiDomain;
  }

  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getPricingApiDomain() {
    return this.PricingApiDomain;
  }

  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getUploadApiDomain() {
    return this.BulkUploadDomain;
  }

  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getVoucherWrapperApiDomain() {
    return this.voucherWrapperApiDomain;
  }

  /**
   *
   *
   * @return {*}
   * @memberof RestApi
   */
  getScormCloudWrapperApiDomain() {
    return this.scormCloudWrapperApiDomain;
  }

  /**
   *
   * @param {*} createUrl
   * @param {*} parameters
   * @param {AxiosRequestConfig} config
   * @return {Promise}
   */
  create(createUrl, parameters, config = {}) {
    return axios.post(createUrl, parameters, config);
  }
  /**
  * Returns an promise
  * @param {string} updateUrl
  * @param {string} parameters
  * @param {AxiosRequestConfig} config
  * @return {Promise}
  */
  update(updateUrl, parameters, config = {}) {
    return axios.patch(updateUrl, parameters, config);
  }
  /**
   *
   *
   * @param {*} deleteUrl
   * @param {*} parameters
   * @param {AxiosRequestConfig} config
   * @return {*}
   * @memberof RestApi
   */
  delete(deleteUrl, parameters, config = {}) {
    return axios.delete(deleteUrl, parameters, config);
  }
  /**
  * Returns an promise
  * @param {listUrl} listUrl
  * @param {AxiosRequestConfig} config
  * @return {Promise}
  */
  list(listUrl, config = {}) {
    return axios.get(listUrl, config);
  }

  /**
  * Returns an promise
  * @param {postUrl} postUrl
  * @param {*} parameters
  * @param {AxiosRequestConfig} config
  * @return {Promise}
  */
  post(postUrl, parameters, config = {}) {
    return axios.post(postUrl, parameters, config);
  }
}
/**
 *
 *
 * @class Events
 * @extends {RestApi}
 */
class Events extends RestApi {
  /**
  **/
  constructor() {
    super();
  }

  /**
   *
   *
   * @param {*} payload
   * @return {*}
   * @memberof Events
   */
  async sendEvent(payload) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/events`;
    const headers = await getAuthHeaders();
    return super.create(url, payload, {headers});
  }
}
/**
 *
 *
 * @class FireBaseAuth
 * @extends {RestApi}
 */
class FireBaseAuth extends RestApi {
  /**
  @param {studentId} studentId
  **/
  constructor(studentId) {
    super();
    this.studentId=studentId;
  }


  /**
   *
   *
   * @param {*} regId
   * @return {*} authToken
   * @memberof FireBaseAuth
   */
  async authenticateRecording(regId) {
    const domain = super.getApiDomain();
    const listUrl=`${domain}/v2/auth/firebase?registration_id=${regId}`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }
}
/**
 TODO:
**/
class Addons extends RestApi {
  /**
   @param {studentId} studentId
  **/
  constructor(studentId = '') {
    super();
    this.studentId=studentId;
  }
  /**
  * Returns an promise
  * @return {Promise}
  */
  async list() {
    const domain = super.getApiDomain();
    const listUrl=`${domain}/v2/students/${this.studentId}/addons`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }
  /**
   *
   *
   * @return {*}
   * @memberof Addons
   */
  async listLead() {
    const domain = super.getApiDomain();
    const listUrl=`${domain}/v2/students/${this.studentId}`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }


  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Addons
   */
  async purchaseAddon(parameters) {
    const domain = super.getPricingApiDomain();
    const url = `${domain}/purchase`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }

  /**
   *
   *
   * @param {*} product
   * @param {*} countryCode
   * @return {*}
   * @memberof Addons
   */
  getPrices(product, countryCode) {
    const domain = super.getPricingApiDomain();
    const url = `${domain}/price?product=${
      product}&country_code=${countryCode}`;
    return super.list(url);
  }

  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Addons
   */
  async giftAddon(parameters) {
    const domain = super.getPricingApiDomain();
    const url = `${domain}/orders`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }

  /**
   *
   *
   * @return {*}
   * @memberof Addons
   */
  async listLeadAndRegistration() {
    const domain = super.getApiDomain();
    const listUrl=
      domain + '/v2/students/' + this.studentId +
      '?include=registration,subscriptions';
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }
}
/**
 TODO:
**/
class Registrations extends RestApi {
  /**
   @param {studentId} studentId
  **/
  constructor(studentId) {
    super();
    this.studentId=studentId;
  }

  /**
   *
   *
   * @param {*} id
   * @return {*}
   * @memberof Registrations
   */
  async getById(id) {
    const domain = super.getApiDomain();
    const listUrl=`${domain}/v2/course-registrations/${id}/?include=modules`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }

  /**
   *
   *
   * @return {*}
   * @memberof Registrations
   */
  async list() {
    const domain = super.getApiDomain();
    const studentId=this.studentId;
    const listUrl=`${domain}/v2/students/${studentId
    }/course-registrations`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }

  /**
  * Returns an promise
  * @return {Promise}
  */
  async listWithIncluded() {
    const domain = super.getApiDomain();
    const studentId=this.studentId;
    const listUrl=`${domain}/v2/students/${studentId
    }/course-registrations/?include=modules`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }
  /**
   *
   *
   * @return {*}
   * @memberof Registrations
   */
  async getStudentRegistrations() {
    const domain = super.getApiDomain();
    const studentId=this.studentId;
    const url = `${domain}/v2/students/${studentId}/registrations/`;
    const headers = await getAuthHeaders();
    return super.list(url, {headers});
  }
  /**
   *
   *
   * @param {*} timeSince
   * @param {*} timeUntil
   * @return {*}
   * @memberof Registrations
   */
  async lessonSchedule(timeSince, timeUntil) {
    const domain = super.getApiDomain();
    const studentId = this.studentId;
    const lessonListUrl = `${domain}/v2/students/${studentId}/lesson-schedules`+
      `?filter[lesson-schedules.start_time][since]=${timeSince}`+
      `&filter[lesson-schedules.start_time][until]=${timeUntil}`;
    const headers = await getAuthHeaders();
    return super.list(lessonListUrl, {headers});
  }
  /**
   *
   *
   * @param {*} courseRegID
   * @param {*} parameters
   * @return {*}
   * @memberof Registrations
   */
  async createRegLaunchLink(courseRegID, parameters) {
    const domain = super.getScormCloudWrapperApiDomain();
    const url = `${domain}/course-registrations/${courseRegID}/launchLink`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }
}
/**
 TODO:
**/
class Schedule extends RestApi {
  /**
   @param {registrationId} registrationId
  **/
  constructor(registrationId) {
    super();
    this.registrationId=registrationId;
  }
  /**
  * Returns an promise
  * @return {Promise}
  */
  get() {
    const domain = super.getApiDomain();
    const url = `${domain}/v2/registrations/${this.registrationId}`;
    return super.list(url);
  }
  /**
  * Returns an promise
  * @param {parameters} parameters
  * @return {Promise}
  */
  async create(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/registrations/`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }
  /**
  * Returns an promise
  * @param {parameters} parameters
  * @return {Promise}
  */
  async update(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/registrations/${this.registrationId}`;
    const headers = await getAuthHeaders();
    return super.update(url, parameters, {headers});
  }
  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Schedule
   */
  async delete(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/course-registrations/${this.registrationId}`;
    const headers = await getAuthHeaders();
    return super.delete(url, parameters, {headers});
  }
}
/**
 TODO:
**/
class Student extends RestApi {
  /**
   @param {studentId} studentId
  **/
  constructor(studentId) {
    super();
    this.studentId = studentId;
  }
  /**
  * Returns an promise
  * @return {Promise}
  */
  async get() {
    const domain = super.getApiDomain();
    const listUrl = `${domain}/v2/students/${this.studentId}`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }

  /**
  * Returns an promise
  * @return {Promise}
  */
  getCreditsBalance() {
    const domain = super.getApiDomain();
    const listUrl = `${domain}/v2/students/${this.studentId}/credit-balance`;
    return super.list(listUrl);
  }

  /**
  * Returns an promise
  * @param {parameters} parameters
  * @return {Promise}
  */
  async update(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/students/${this.studentId}`;
    const headers = await getAuthHeaders();
    return super.update(url, parameters, {headers});
  }

  /**
   *
   *
   * @return {*}
   * @memberof Addons
   */
  async listLeadAndSubscription() {
    // Testing same domain proxy
    const domain = super.getApiDomain();
    const listUrl = `${domain}/v2/students/` +
      `${this.studentId}?include=subscriptions`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }

  /**
  * Returns an promise
  * @return {Promise}
  */
  async getAllSubcriptions() {
    const domain = super.getApiDomain();
    const getAllSubscriptionsUrl=
  `${domain}/v2/students/${this.studentId}/subscriptions`;
    const headers = await getAuthHeaders();
    return super.list(getAllSubscriptionsUrl, {headers});
  }

  /**
  * Returns an promise
  * @return {Promise}
  */
  async listPaymentSources() {
    const domain = super.getApiDomain();
    const listPaymentSourcesUrl=
      `${domain}/v2/students/${this.studentId}/payment-sources`;
    const headers = await getAuthHeaders();
    return super.list(listPaymentSourcesUrl, {headers});
  }
}
/**
 *
 *
 * @export
 * @class Subscription
 * @extends {RestApi}
 */
export class Subscription extends RestApi {
  /**
   * Creates an instance of Subscription.
   * @param {*} subId
   * @memberof Subscription
   */
  constructor(subId) {
    super();
    this.subId=subId;
  }

  /**
   *
   * @param {*} parameters
   *
   * @return {*}
   * @memberof Subscription
   */
  async resumeMembership(parameters) {
    const domain = super.getPricingApiDomain();
    const url=`${domain}/resume-subscription`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }

  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Subscription
   */
  async updateSubscription(parameters) {
    const domain = super.getPricingApiDomain();
    const url=`${domain}/subscriptions/${this.subId}`;
    const headers = await getAuthHeaders();
    return super.update(url, parameters, {headers});
  }

  /**
   *
   * @param {*} parameters
   * @return {*}
   */
  async reactivateSubscription(parameters) {
    const domain = super.getPricingApiDomain();
    // const url=`${domain}/subscriptions/${this.subId}/reactivate`;
    const url=`${domain}/comms/reactivate-subscription`;
    const headers = await getAuthHeaders();
    return super.post(url, parameters, {headers});
  }
  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Subscription
   */
  async pauseSubscription(parameters) {
    const domain = super.getPricingApiDomain();
    const url=`${domain}/pause-subscription`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }
  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Subscription
   */
  async cancelSubscription(parameters) {
    const domain = super.getPricingApiDomain();
    const url=`${domain}/subscriptions/${this.subId}`;
    const headers = await getAuthHeaders();
    return super.delete(url, parameters, {headers});
  }
  /**
   *
   * @param {*} studentId
   * @param {*} preferredPlatform
   * @return {*}
   * @memberof Subscription
   */
  async getSubscriptionPlans(studentId, preferredPlatform = null) {
    const domain = super.getPricingApiDomain();
    let url = `${domain}/subscription-plans?student_id=${
      studentId}`;
    if (preferredPlatform) {
      url = `${url}&preferred_platform=${preferredPlatform}`;
    }
    const headers = await getAuthHeaders();
    return super.list(url, {headers});
  }

  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Subscription
   */
  async reactivateSubscriptionForLifetime(parameters) {
    const domain = super.getPricingApiDomain();
    const url = `${domain}/reactivate-subscription`;
    const headers = await getAuthHeaders();
    return super.post(url, parameters, {headers});
  }
}
/**
 *
 *
 * @export
 * @class Signup
 * @extends {RestApi}
 */
export class Signup extends RestApi {
  /**
   * Creates an instance of Signup.
   * @param {*} studentId
   * @memberof Signup
   */
  constructor(studentId) {
    super();
    this.studentId=studentId;
  }

  /**
   *
   * @param {*} parameters
   * @param {*} headers // TODO: remove param
   * @return {*}
   */
  signup(parameters, headers) {
    const domain = super.getSignupApiDomain();
    const url=`${domain}/signup`;
    return super.create(url, parameters, {headers});
  }

  /**
   *
   * @param {*} parameters
   * @return {*}
   */
  getMigrationStatus(parameters) {
    const domain = super.getSignupApiDomain();
    const url = `${domain}/migration-status`;
    return super.create(url, parameters);
  }

  /**
   * TODO: remove
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Signup
   */
  createPassword(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/users/${this.studentId}`;
    return super.update(url, parameters);
  }

  /**
   *
   *
   * @param {*} authToken
   * @return {*}
   * @memberof Signup
   */
  async getStudentDetails(authToken) {
    const domain = super.getSignupApiDomain();
    // TODO: remove param
    const url=`${domain}/me/?auth_token=${authToken}`;
    const headers = await getAuthHeaders();
    return super.list(url, {headers});
  }

  /**
   *
   *
   * @param {*} voucherCode
   * @param {*} parameters
   * @return {*}
   * @memberof Signup
   */
  async createVoucherRedemption(voucherCode, parameters) {
    const domain = super.getVoucherWrapperApiDomain();
    const url = `${domain}/vouchers/${voucherCode}/redemption`;
    const headers = await getAuthHeaders();
    return super.create(url, parameters, {headers});
  }
}
/**
 * TODO: remove
 *
 * @export
 * @class Signup
 * @extends {RestApi}
 */
export class Profile extends RestApi {
  /**
   * Creates an instance of Profile.
   * @param {*} profileId
   * @memberof Profile
   */
  constructor(profileId) {
    super();
    this.profileId=profileId;
  }

  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Profile
   */
  createProfile(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/studentprofiles`;
    return super.create(url, parameters);
  }
  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Signup
   */
  updateProfile(parameters) {
    const domain = super.getApiDomain();
    const url=`${domain}/v2/studentprofiles/${this.profileId}`;
    return super.update(url, parameters);
  }
}

/**
 *
 *
 * @class Assessments
 * @extends {RestApi}
 */
class Assessments extends RestApi {
  /**
   @param {regId} regId
  **/
  constructor(regId) {
    super();
    this.regId=regId;
  }

  /**
   *
   *
   * @param {*} params
   * @return {*} returns assignment list
   * @memberof Assessments
   */
  async getAssignmentData() {
    const domain = super.getAssessmentApiDomain();
    const listUrl=`${domain}/course-assessments?reg_id=${this.regId}`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }

  /**
   *
   *
   * @param {*} countryCode
   * @return {*} returns pricing list
   * @memberof Assessments
   */
  getPricingInfo(countryCode) {
    const domain = super.getPricingApiDomain();
    const getPriceUrl=
      `${domain}/price?product=module-assessment-retake&country_code=${
        countryCode}`;
    return super.list(getPriceUrl);
  }
}

/**
 Handling api for certificate data
**/
class Certificate extends RestApi {
  /**
   * Creates an instance of Certificate.
   */
  constructor() {
    super();
  }

  /**
   *
   *
   * @param {*} formId
   * @param {*} responseId
   * @return {*}
   * @memberof Certificate
   */
  getCertificateData(formId, responseId) {
    const domain = super.getAssessmentApiDomain();
    const certificateDetailsUrl=
    `${domain}/certificate/?form_id=${formId}&response_id=${responseId}`;
    return super.list(certificateDetailsUrl).then((res) => (res.data));
  }
}

/**
 TODO:
**/
class Webinar extends RestApi {
  /**
   @param {registrationId} registrationId
  **/
  constructor(registrationId) {
    super();
    this.registrationId=registrationId;
  }
  /**
  * TODO: remove
  * Returns an promise
  * @return {Promise}
  */
  get() {
    const domain = super.getApiDomain();
    const url = `${domain}/v2/registrations/${this.registrationId}`;
    return super.list(url);
  }
}
/**
 *
 *
 * @class Prices
 * @extends {RestApi}
 */
class Prices extends RestApi {
  /**
   * Creates an instance of Prices.
   * @param {*} studentId
   * @memberof Prices
   */
  constructor(studentId) {
    super();
    this.studentId = studentId;
  }

  /**
   *
   * @param {*} preferredPlatform
   * @return {*}
   * @memberof Prices
   */
  async getStudentPlans(preferredPlatform = null) {
    const domain = super.getPricingApiDomain();
    let url = `${domain}/subscription-plans?student_id=${
      this.studentId}`;
    if (preferredPlatform) {
      url = `${url}&preferred_platform=${preferredPlatform}`;
    }
    const headers = await getAuthHeaders();
    return super.list(url, {headers});
  }

  /**
   *
   *
   * @param {*} parameters
   * @return {*}
   * @memberof Prices
   */
  async switchSubscription(parameters) {
    const domain=super.getPricingApiDomain();
    const url=`${domain}/subscriptions/`;
    const headers = await getAuthHeaders();
    return super.update(url, parameters, {headers});
  }
}

/**
 *
 *
 * @class AddMember
 * @extends {RestApi}
 */
class AddMember extends RestApi {
  /**
   @param {studentId} studentId
  **/
  constructor(studentId) {
    super();
    this.studentId=studentId;
  }
}

/**
 *
 *
 * @class HCDRequest
 * @extends {RestApi}
 */
class HCDRequest extends RestApi {
  /**
   @param {studentId} studentId
  **/
  constructor(studentId) {
    super();
    this.studentId=studentId;
  }

  /**
   *
   *
   * @return {*}
   * @memberof HCDRequest
   */
  async list() {
    const domain = super.getApiDomain();
    const studentId=this.studentId;
    const listUrl=`${domain}/v2/students/${studentId
    }/hcd-requests`;
    const headers = await getAuthHeaders();
    return super.list(listUrl, {headers});
  }
}

export default {
  Addons,
  Registrations,
  Profile,
  Schedule,
  Assessments,
  Student,
  Subscription,
  Signup,
  Certificate,
  Events,
  FireBaseAuth,
  Webinar,
  Prices,
  AddMember,
  HCDRequest,
};
